export default __webpack_public_path__ + "static/media/greypdf_icon.a3b7e7d4.svg";